import { defineStore } from 'pinia';
export const useCartStore = defineStore('cart', {
    state: () => ({
        cart: {
            id: '', is_virtual: false, total_quantity: 0, shipping_addresses: [],
        },
    }),
});
